<div class="app-list">
    <div class="lined-input-group filters">
        <input (input)="searchText = $event.target.value" [value]="searchText" class="form-control app-filter"
               placeholder="Search: Event or Member" type="text"/>
        <select (change)="filterStatus = $event.target.value" class="form-select form-control app-filter state-filter">
            <option disabled hidden value="">Select State</option>
            <option value="">All</option>
            <option value="Approved">Approved</option>
            <option value="Cancelled">Cancelled</option>
            <option value="Declined">Declined</option>
            <option value="ExpensesApproved">Expenses Approved</option>
            <option value="ExpensesDeclined">Expenses Declined</option>
            <option value="ExpensesDue">Expenses Due</option>
            <option value="ExpensesOverdue">Expenses Overdue</option>
            <option value="ExpensesSubmitted">Expenses Submitted</option>
            <option value="Submitted">Submitted</option>
        </select>
    </div>
    <table class="list-table app-list-table">
        <thead>
        <tr>
            <th (click)="setOrder('event.name')" [class.active]="order === 'event.name'" class="header">
                Event<span [hidden]="reverse">▼</span>
                <span [hidden]="!reverse">▲</span>
            </th>
            <th (click)="setOrder('createdAt')" [class.active]="order === 'createdAt'" class="header">
                Created<span [hidden]="reverse">▼</span>
                <span [hidden]="!reverse">▲</span>
            </th>
            <th (click)="setOrder('applicantName')" [class.active]="order === 'applicantName'" class="header">
                Member<span [hidden]="reverse">▼</span>
                <span [hidden]="!reverse">▲</span>
            </th>
            <th (click)="setOrder('displayTotal')" [class.active]="order === 'displayTotal'" class="header">
                Expense<span [hidden]="reverse">▼</span>
                <span [hidden]="!reverse">▲</span>
            </th>
            <th (click)="setOrder('status')" [class.active]="order === 'status'" class="header">
                State<span [hidden]="reverse">▼</span>
                <span [hidden]="!reverse">▲</span>
            </th>
        </tr>
        </thead>
        <tbody>
        <tr *ngIf="loading">
            <td colspan="5">
                    <span class="app-loading">
                        <svg class="spinner" viewBox="25 25 50 50">
                            <circle class="path" cx="50" cy="50" fill="none" r="20" stroke-miterlimit="10"
                                    stroke-width="2"/>
                        </svg>
                    </span>
            </td>
        </tr>
        <tr *ngFor="let pdApp of pdApps|orderBy: this.order:reverse:true |searchFilter: searchText |statusFilter: filterStatus |paginate: {itemsPerPage: 20, currentPage: this.tablePage}"
            class="list-row">
            <td>
                <a [routerLink]="[linkToEdit + pdApp.id]">
                    {{ pdApp.eventName }}
                </a>
            </td>
            <td title="{{ pdApp.createdAt }}">
                {{ getAgo(pdApp.createdAt) }}
            </td>
            <td>
                    <span title="{{pdApp.applicantName}}">
                        {{ pdApp.applicantName }}
                    </span>
            </td>
            <td>
                ${{ pdApp.displayTotal }}
            </td>
            <td>
                {{ pdApp.status }}
            </td>
        </tr>
        </tbody>
    </table>
    <div *ngIf="!loading && (!pdApps || !pdApps.length)">
        No applications match the current filters.
    </div>
    <pagination-controls (pageChange)="this.tablePage = $event"></pagination-controls>
    <div class="d-flex justify-content-end align-items-center gap-2">
        <div>Have some time to wait?</div>
        <button (click)="loadAllApps()" class="btn btn-primary">Load historical PD's</button>
    </div>
</div>
